/**
 * `#cta` — bản tiếng Anh, lấy từ thuộc tính `data-en` trong `template.html` (1041–1052).
 * Hình dạng phải khớp `vi/cta.ts`; lệch một khoá là lỗi biên dịch.
 */
export const cta = {
  heading: 'See Nexa on your own workflow.',
  lead: 'Start a free trial, or book a 30-minute demo with the NewEra Inc. team.',
  primary: 'Start free trial',
  secondary: 'Book a demo',
  /** Giữ nguyên ở mọi ngôn ngữ — chữ thương hiệu, không dịch. */
  wordmark: 'Reimagined',
};
